import Spanish from "assets/images/header-images/Spanish.svg";
import Japanese from "assets/images/header-images/japanese.png";
import Chinese from "assets/images/header-images/chinese.svg";
import Portuguese from "assets/images/header-images/portuguese.svg";
import Arabic from "assets/images/header-images/arabic.png";
import Vietnamese from "assets/images/header-images/veitnamese.png";
import French from "assets/images/header-images/french.png";
import Dutch from "assets/images/header-images/dutch.png";
import Italian from "assets/images/header-images/italian.png";
import Turkish from "assets/images/header-images/turkish.png";
import German from "assets/images/header-images/german.svg";
import Polish from "assets/images/header-images/polish.png";
import Korean from "assets/images/header-images/korean.png";
// import Hungarian from "assets/images/header-images/hungrarian.png";
import Russian from "assets/images/header-images/russian.svg";
import Hebrew from "assets/images/header-images/hebrew.svg";
export const Services = [
  {
    list: "Business Translation",
    link: "/business-translation.php",
    byline: "120 languages with 24-hour delivery for all businesses types",
  },
  {
    list: "Certified Translation",
    link: "/certified-translation.php",
    byline:
      "Certified translation with professional translators for official use",
  },
  // {
  //   list: "Document Translation",
  //   link: "/document-translation-services",
  //   byline:
  //     "For more complex translation needs, industry-specific document translation.",
  // },
  // {
  //   list: "Website Translation",
  //   link: "/website-translation.php",
  //   byline: "Full and partial translation or localization of websites.",
  // },
  // { list: "Legal Translation", link: "/legal-translation", byline :"End-to-end translation services for your business for all your globalization needs." },
  // { list: "Medical Translation" , link : "/medical-translation", byline :"End-to-end translation services for your business for all your globalization needs." },
  // { list: "Technical Translation", link: "/technical-translation" },
  // { list: "Marketing Translation" ,  link: "/marketing-translation"},
  // { list: "Financial Translation" , link : "/financial-translation" },
  // { list: "Video Translation" , link : "/video-translation" },
  // { list: "Localization" , link  : "/localization-services"},
  // {
  //   list: "Software Translation",
  //   link: "/software-translation.php",
  //   byline:
  //     "Translation and localization of apps, games and other sector-specific software.",
  // },
  // { list: "Interpreting" , link : "/interpretation-services" },
  // { list: "Translation On-Demand" , link : "/services/real-time-translation" },
];

export const Services2 = [
  {
    list: "Document Translation",
    link: "/document-translation-services",
    byline: "",
  },
  {
    list: "Website Translation",
    link: "/website-translation.php",
    byline: "",
  },
  {
    list: "Software Translation",
    link: "/software-translation.php",
    byline: "",
  },
];

export const Industries = [
  { data: "Legal", link: "/legal-translation.php" },
  { data: "Healthcare", link: "/medical-translation.php" },
  { data: "Financial", link: "/financial-translation.php" },
  { data: "Marketing", link: "/marketing-translation.php" },
  { data: "Technical", link: "/technical-translation.php" },
  {
    data: "Automotive",
    link: "/industries/automotive",
  },
  {
    data: "Government",
    link: "/industries/government",
  },
];

export const Languages=[
  { list: "Arabic ", 
  img_link: Arabic, 
  link: "/languages/arabic" },
  {
    list: "Korean",
    img_link: Korean,
    link: "/languages/korean",
  },
  {
    list: "Chinese ",
    img_link: Chinese,
    link: "/languages/chinese",
  },
  { list: "Polish", 
  img_link: Polish, 
  link: "/languages/polish"},

  { list: "Dutch", 
  img_link: Dutch, 
  link: "/languages/dutch" },
  {
    list: "Portuguese",
    img_link: Portuguese,
    link: "/languages/portuguese",
  },
  {
    list: "French ",
    img_link: French,
    link: "/languages/french",
  },
  {
    list: "Russian",
    img_link: Russian,
    link: "/languages/russian",
  },
  {
    list: "German",
    img_link: German,
    link: "/languages/german",
  },
  { list: "Turkish", 
  img_link: Turkish, 
  link: "/languages/turkish"},
  {
    list: "Hebrew",
    img_link: Hebrew,
    link: "/languages/hebrew"
  },
  {
    list: "Vietnamese",
    img_link: Vietnamese,
    link: "/vietnamese-translation.php",
  },
  {
    list: "Italian",
    img_link: Italian,
    link: "/languages/italian",
  },
  {
    list: "Spanish ",
    img_link: Spanish,
    link: "/english-to-spanish-translation-service.php",
  },
  {
    list: "Japanese",
    img_link: Japanese,
    link: "/languages/japanese",
  },
  {
    list: "More Languages",
    underline: "underline",
    img_link: "",
    link: "/language-translation-service.php",
  }, 
]
export const AboutData = [
  { link: "/quality-policy", list: "Quality Policy" },
  { link: "/our-customers", list: "Our Customers" },
  { link: "/reviews.php", list: "Reviews" },
  { link: "/recent-translations.php", list: "Case Studies" },
  { link: "/translators", list: "Our Translators" },
  { link: "/user/provider/createaccount", list: "Register as a translator" },
];
